import React, { useEffect, useState } from "react";
import HelmetContent from "../../Layout/HelmerContent";
import Loader from "../../Components/Loader/Loader";
import HallLayout from "../../Layout/HallLayout/HallLayout";
import NewlywedsHero from "./Components/NewlywedsHero/NewlywedsHero";
import NewlywedsComponent from "./Components/NewlywedsComponent/NewlywedsComponent";

export default function HallsNewlyweds() {
  const [isLoading, setIsLoading] = useState(true);
  let loaderTimeout;

  useEffect(() => {
    // Set a timeout to mark loading as complete after 3 seconds
    loaderTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    // Clear the timeout if the component unmounts or if needed
    return () => {
      clearTimeout(loaderTimeout);
    };
  }, []);
  return (
    <>
      <HelmetContent
        title={"Za mladence"}
        description={
          "U restoranu Košuta, slavimo ljubav i nove početke! Za mladi bračni par pripremili smo posebne poklone, elegantno dekorisanu salu i vrhunski gastronomski doživljaj. Doživite nezaboravne trenutke uz pažljivo birane specijalitete i besprekornu uslugu, dok slavite svoj novi životni korak u prelepom ambijentu."
        }
        canonical={"https://restorankosuta.rs/mladenci"}
        keywords={
          "sale, sala, izdavanje sala, izdavanje sale, rođendani, seminari, venčanja, sve vrste proslava, kamin, grande, svečana sala, kamin sala, sala grande, bašta, mladenci"
        }
      />
      {isLoading ? (
        <Loader />
      ) : (
        <HallLayout>
          <NewlywedsHero />
          <NewlywedsComponent />
        </HallLayout>
      )}
    </>
  );
}
